var AssetsGrid,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

AssetsGrid = (function() {
  function AssetsGrid(options) {
    if (options == null) {
      options = {};
    }
    this.select_asset = __bind(this.select_asset, this);
    this.set_as_cover = __bind(this.set_as_cover, this);
    this.remove = __bind(this.remove, this);
    this.move = __bind(this.move, this);
    this.add = __bind(this.add, this);
    this.load_more = __bind(this.load_more, this);
    this.load = __bind(this.load, this);
    this.reload = __bind(this.reload, this);
    this.add_container = __bind(this.add_container, this);
    this.per_page = options.per_page != null ? options.per_page : 100;
    this.cart_enabled = options.cart_enabled != null ? true : false;
    this.info = options.info;
    if (typeof upload !== "undefined" && upload !== null) {
      this.upload = upload;
    }
    Observable(this, 'loaded', false);
    Observable(this, 'loading', false);
    Observable(this, 'sorting_enabled', options.sorting_enabled);
    Observable(this, 'count', 0);
    Observable(this, 'page', 0);
    ObservableArray(this, 'assets');
    Observable(this, 'asset');
    Observable(this, 'container');
    ObservableArray(this, 'containers');
    $(window).scroll((function(_this) {
      return function() {
        if (!_this.loaded()) {
          return;
        }
        if ($(window).scrollTop() !== ($(document).height() - $(window).height())) {
          return;
        }
        if (!(_this.count() > _this.assets().length)) {
          return;
        }
        return _this.load_more();
      };
    })(this));
    $(window).ready((function(_this) {
      return function() {
        if ((typeof upload) !== 'undefined') {
          return upload.callback('done', function(e, data) {
            return $.each(data.result, function(index, file) {
              _this.container().asset_add(file.id);
              return _this.add(file);
            });
          });
        }
      };
    })(this));
  }

  AssetsGrid.prototype.add_container = function(container, options) {
    this.containers.push(container);
    return container.subscribe((function(_this) {
      return function(container) {
        _this.container(container);
        return _this.load();
      };
    })(this));
  };

  AssetsGrid.prototype.reload = function() {
    return this.load();
  };

  AssetsGrid.prototype.load = function(page, more, options) {
    if (page == null) {
      page = 0;
    }
    if (more == null) {
      more = void 0;
    }
    this.loading(true);
    if (this.container() === null) {
      this.loading(false);
      if (this.upload != null) {
        this.upload.disable();
      }
      this.assets.removeAll();
      return;
    }
    if (this.upload != null) {
      this.upload.enable();
    }
    if ($.isNumeric(page) !== true) {
      page = 0;
    }
    if (more === void 0) {
      this.loaded(false);
    }
    this.count(0);
    this.page(page);
    if (options == null) {
      options = {};
    }
    options.page = page;
    options.per_page = this.per_page;
    return this.container().assets(options, (function(_this) {
      return function(response) {
        var a, asset, _i, _len, _ref;
        if (more === void 0) {
          _this.assets.removeAll();
        }
        _this.count(Number(response.count));
        if (response.assets !== void 0) {
          _ref = response.assets;
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            asset = _ref[_i];
            a = Asset(asset);
            if (_this.cart_enabled) {
              a = Purchasable(a);
            }
            _this.assets.push(a);
          }
        }
        _this.loaded(true);
        _this.loading(false);
        if ((_this.count() - _this.assets().length) < _this.per_page && _this.count() > _this.assets().length) {
          return _this.load_more();
        }
      };
    })(this));
  };

  AssetsGrid.prototype.load_more = function() {
    if ((this.page() * this.per_page) >= this.assets().length) {
      return;
    }
    return this.load(this.page() + 1, true);
  };

  AssetsGrid.prototype.add = function(asset) {
    this.assets.unshift(asset);
    return this.count(Number(this.count()) + 1);
  };

  AssetsGrid.prototype.move = function(element) {
    var asset, to;
    asset = element.item;
    to = element.targetIndex;
    return this.container().asset_update(asset.id, {
      sort: to
    });
  };

  AssetsGrid.prototype.remove = function(asset) {
    if (confirm('Really remove this image from the gallery?')) {
      return this.container().asset_delete(asset.id, (function(_this) {
        return function() {
          return _this.assets.remove(asset);
        };
      })(this));
    }
  };

  AssetsGrid.prototype.set_as_cover = function(asset) {
    if (this.container().set_cover == null) {
      return;
    }
    return this.container().set_cover(asset, (function(_this) {
      return function(response) {
        var a, assets, _i, _len;
        assets = _this.assets();
        for (_i = 0, _len = assets.length; _i < _len; _i++) {
          a = assets[_i];
          a.is_cover(Number(asset.id) === Number(a.id));
        }
        return _this.assets(assets);
      };
    })(this));
  };

  AssetsGrid.prototype.select_asset = function(asset) {
    return this.asset(asset);
  };

  return AssetsGrid;

})();

//# sourceMappingURL=assetsgrid.js.map
